
// src/config/index.js
// import * as msal from '@azure/msal-browser';
var config

if (process.env.RAILS_ENV == 'production')
config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'https://www.getgamba.com/',
  baseApiUrl: 'https://www.getgamba.com/api/v3',
  webSocketUrl: 'wss://ws.getgamba.com/v3websocket',
  textareaHtml: '/n/textarea.html',
  googleAnalyticsID: 'UA-36388017-4',
  mixpanelToken: '182757b1ecae6c9df7424454b3842780',
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw', 
              scope: [
                "https://www.googleapis.com/auth/calendar.readonly",
                "https://www.googleapis.com/auth/drive.readonly",
                "https://www.googleapis.com/auth/drive.file",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/userinfo.profile"
              ],
              redirect_uri: 'https://www.getgamba.com/api/v3/app_redirect/google_oauth2',
              gcmSenderId: '1019125704984',
              clientSecret: '_4AsfaUTewfYaKOT-Bv6qX8w',
              clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
              clientId: '175355942715.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: process.env.RAILS_ENV,
    isPerformMonitorEnable: true  // パフォーマンスモニタリングを有効化
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  msal: {
    auth: {
      clientId: "bb7a36f6-a000-4308-a8ec-56c04a3d18ff",  // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "https://www.getgamba.com/window-close"
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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",
  },
  env: 'production',
}

else if (process.env.RAILS_ENV == 'staging')
config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'https://dev.getgamba.com/',
  baseApiUrl: 'https://dev.getgamba.com/api/v3',
  webSocketUrl: 'wss://dev.getgamba.com/v3websocket',
  textareaHtml: '/n/textarea.html',
  googleAnalyticsID: 'UA-36388017-5',
  mixpanelToken: undefined,
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw', 
              scope: [
                "https://www.googleapis.com/auth/calendar.readonly",
                "https://www.googleapis.com/auth/drive.readonly",
                "https://www.googleapis.com/auth/drive.file",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/userinfo.profile"
              ],
              redirect_uri: 'https://dev.getgamba.com/api/v3/app_redirect/google_oauth2',
              gcmSenderId: '156469777344',
              clientSecret: 'v6aBZN-zPi8Y-HL8k7ubxM0a',
              clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
              clientId: '175355942715-me6hh7vj8vlcggfvd6s09kec7nrft59a.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: process.env.RAILS_ENV,
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  env: 'staging',
  msal: {
    auth: {
      clientId: "dba35891-65ac-479e-9271-a59996a3b70e",  // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "https://dev.getgamba.com/window-close"
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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",
  },
}

else
config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'http://localhost:3000/',
  baseApiUrl: 'http://localhost:3000/api/v3',
  webSocketUrl: 'ws://localhost:3003/v3websocket',
  textareaHtml: '/textarea.html',
  googleAnalyticsID: 'UA-36388017-5',
  mixpanelToken: undefined,
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw', 
              scope: [
                "https://www.googleapis.com/auth/calendar.readonly",
                "https://www.googleapis.com/auth/drive.readonly",
                "https://www.googleapis.com/auth/drive.file",
                "https://www.googleapis.com/auth/userinfo.email",
                "https://www.googleapis.com/auth/userinfo.profile"
              ],
              redirect_uri: 'http://localhost:3000/api/v3/app_redirect/google_oauth2',
              gcmSenderId: '156469777344',
              clientSecret: 'OVCKw0a5OxVWRzKsgRln8nmy',
              clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
              clientId: '175355942715-9hr5aakabmdc5diba82k42gi2nspckkq.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: 'development',
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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",
    region: 'ap-northeast-1'
  },
  msal: {
    auth: {
      clientId: "dba35891-65ac-479e-9271-a59996a3b70e",  // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "http://localhost:8888/"
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    // system: {
    //   loggerOptions: {
    //       loggerCallback: (level, message, containsPii) => {
    //           if (containsPii) {
    //               return;
    //           }
    //           switch (level) {
    //               case msal.LogLevel.Error:
    //                   console.error(message);
    //                   return;
    //               case msal.LogLevel.Info:
    //                   console.info(message);
    //                   return;
    //               case msal.LogLevel.Verbose:
    //                   console.debug(message);
    //                   return;
    //               case msal.LogLevel.Warning:
    //                   console.warn(message);
    //                   return;
    //           }
    //       }
    //   }
    // },
  },
  env: 'development',
}

config.codePushKeys = {
  android: {
    staging: "_Xii8gQtfTNcoMoOESkOPy7cokav5614df7a-9884-424f-9dae-4f673820adf9",
    production: "nBreEWuVGbl50Axz4JJaTZoo24o85614df7a-9884-424f-9dae-4f673820adf9",
  },
  ios: {
    staging: "TY4DtBfMkrWAdtTx5TS9mKP5S95_5614df7a-9884-424f-9dae-4f673820adf9",
    production: "h-mpAI2cwKfon4_9_yRO6wT8VGQk5614df7a-9884-424f-9dae-4f673820adf9",
  }
}
config.emojiPNG = 'https://cdn.jsdelivr.net/emojione/assets/4.5/png/128/'
config.BUILD_NO = process.env.BUILD_NO
config.timerexUrl = 'https://timerex.net/s/gambarese/6c59c6dd'

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js